<template>
  <section class="w-full space-x-2 flex-items-center">
    <TableExport
      @exportAsCSV="exportAsCSV"
      :fileType="fileType"
      v-if="isExport"
    />

    <PushERP @pushToERP="pushToERP" :pushedERP="pushedERP" v-if="isERP" />

    <InputSystem
      v-model="queryVal.search"
      placeholder="Search"
      status="tableInput"
      type="text"
      v-if="isSearch"
    >
      <img src="@/assets/svg/search.svg" />
    </InputSystem>

    <div
      :class="[
        'flex items-center space-x-3 font-normal !ml-auto',
        containerClass,
      ]"
    >
      <section v-if="isPagination" class="flex gap-x-4">
        <button class="pagination-button" @click="refreshTable">
          <img src="@/assets/svg/refresh.svg" />
        </button>

        <div
          @click="toggleRowsPerPageMenu"
          class="flex items-center px-4 space-x-1 border border-black rounded-md cursor-pointer 2"
        >
          <button
            type="button"
            aria-haspopup="true"
            aria-controls="rows_per_page_menu"
            class="text-sm underline text-estationsGreen-500 underline-offset-4"
          >
            {{ (queryVal.page - 1) * queryVal.rowsPerPage + 1 }}

            - {{ paginationCount }}
          </button>

          <Menu
            ref="menu"
            id="rows_per_page_menu"
            :model="rowsPerPageMenu"
            :popup="true"
          >
            <template #submenulabel="{ item }">
              <span class="text-sm font-bold text-primary">{{
                item.label
              }}</span>
            </template>
            <template #item="{ item, props }">
              <a class="flex items-center" v-bind="props.action">
                <span class="text-sm">{{ item.label }}</span>
              </a>
            </template>
          </Menu>

          <p class="text-sm">of {{ formattedTotalCount }}</p>
          <img src="@/assets/svg/arrow-down.svg" alt="" class="w-4" />
        </div>

        <div class="flex items-center space-x-3">
          <button
            :class="[
              pagination?.currentPage == 1
                ? 'cursor-not-allowed'
                : 'cursor-pointer',
            ]"
            class="pagination-button"
            @click="handlePreviousPage"
          >
            <img src="@/assets/svg/arrow-left.svg" />
          </button>

          <p class="text-sm">{{ formattedPage }} - {{ formattedPages }}</p>

          <button
            :class="[
              pagination?.currentPage >= pagination?.totalPages
                ? 'cursor-not-allowed'
                : 'cursor-pointer',
            ]"
            class="pagination-button"
            @click="handleNextPage"
          >
            <img src="@/assets/svg/arrow-right.svg" />
          </button>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import Menu from "primevue/menu";
import { successToast, translateText } from "@/core/helpers/utility";

export default {
  components: {
    Menu,
  },
  props: {
    exportName: {
      type: String,
      default: "",
    },

    fileType: {
      type: String,
      default: "all",
      required: false,
    },

    queryVal: {
      type: Object,
      required: true,
      default: () => ({ search: "", page: 1, rowsPerPage: 20 }),
    },

    pagination: {
      type: Object,
      required: true,
      default:{}
    },
    containerClass: {
      type: String,
      default: "",
    },

    rowsPerPageOptions: {
      type: Array,
      default: () => [10, 20, 50, 100],
    },
    isExport: {
      type: Boolean,
      default: true,
    },
    isSearch: {
      type: Boolean,
      default: true,
    },
    isPagination: {
      type: Boolean,
      default: true,
    },

    // 🚨ERP SETUP
    isERP: {
      type: Boolean,
      default: false,
    },
    pushedERP: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    paginationCount() {
      const pagCalc = this.queryVal.rowsPerPage * this.queryVal.page;
      const pagTotalData = this.pagination?.totalData;
      return pagCalc > pagTotalData ? pagTotalData : pagCalc;
    },
    formattedTotalCount() {
      return this.formatNumber(this.pagination?.totalData ?? 0);
    },
    formattedPage() {
      return this.formatNumber(this.pagination?.currentPage ?? 0);
    },
    formattedPages() {
      return this.formatNumber(this.pagination?.totalPages ?? 0);
    },

    formattedRowsPerPage() {
      return this.formatNumber(this.queryVal.rowsPerPage);
    },
    rowsPerPageMenu() {
      return [
        {
          label: "Rows per page",
          items: this.rowsPerPageOptions.map((option) => ({
            label: option,
            command: () => this.handleRowsPerPageChange(option),
          })),
        },
      ];
    },
  },

  methods: {
    refreshTable() {
      this.queryVal.page = 1;
      this.queryVal.rowsPerPage = 10;
      this.queryVal.search = "";
      this.getPaginationData();
    },
    getPaginationData() {
      this.$emit("paginationData", this.queryVal);
    },
    handleNextPage() {
      if (this.pagination.totalPages > 1) {
        if (this.queryVal.page < this.pagination.totalPages) {
          this.queryVal.page = this.queryVal.page + 1;
        } else {
          this.queryVal.page = 1;
        }
        // console.log(this.queryVal, "hhh");
        this.getPaginationData();
      }
    },
    handlePreviousPage() {
      if (this.queryVal.page > 1) {
        this.queryVal.page--;
        this.getPaginationData();
      }
    },
    toggleRowsPerPageMenu(event) {
      this.$refs.menu.toggle(event);
    },
    formatNumber(number) {
      return Intl.NumberFormat().format(number);
    },
    // refresh() {
    // 	this.$emit("refresh");
    // },

    handleRowsPerPageChange(rowsPerPage) {
      this.queryVal.rowsPerPage = rowsPerPage;
      this.queryVal.page = 1;
      this.getPaginationData();
    },
    exportAsCSV(type) {
      this.$emit("exportCSV", type);
    },
    pushToERP(data) {
      this.$emit("pushERP", data);
    },
    // handleNextPage() {
    //   this.$emit("nextPage");
    // },
    // handlePreviousPage() {
    //   this.$emit("previousPage");
    // },
  },
};
</script>

<style>
.pagination-button {
  @apply h-8 w-8 grid place-items-center rounded-full hover:bg-gray-100 duration-300;
}
</style>
